export default __webpack_public_path__ + "static/media/pantry1-afterI-480w.67722cec.avif";